import { ValidationAction, ValidationError, ViolationType } from '../Validation';

export default class RuleViolationWithActionMapper {
  public static toDomain = (dto: CoreServiceAPI.RuleViolationWithActionDto): ValidationError => ({
    message: dto.violationMessage,
    fixable: dto.fixable,
    type: dto.type as ViolationType,
    action: dto.action as ValidationAction,
    articleNumber: dto.articleNumber,
  });
}
